// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import "babel-polyfill";
import Vue from "vue";
import App from "./App";
import router from "./router";
import moment from "moment";
import xiaomaolv from "./config/xiaomaolv";
import tongxiang from "./config/tongxiang";
import rental from "./config/rental";
import zhongluo from "./config/zhongluo";
import duoduo from "./config/duoduo";
import xianlvv2 from "./config/xianlvv2";
import kaifeng from "./config/kaifeng";
import ganzhou from "./config/ganzhou";

Vue.prototype.xiaomaolv = xiaomaolv;
Vue.prototype.duoduo = duoduo;
// 时间计算
Vue.prototype.$moment = moment;
// axios.defaults.timeout = 5000;
// axios.defaults.withCredentials=true;
import axios from "axios";
import domMessage from './utils/messageOnce'

import  VueCookies from "vue-cookies";
Vue.use(VueCookies)


var baseURL, opsBaseURL, ossBaseUrl;

if (window.location.host == "console.donkeysgo.com") {
  localStorage.setItem('total_Global', JSON.stringify(xiaomaolv))
  localStorage.setItem('total_switchhost', 'true')
  baseURL = "//api.donkeysgo.com/";
  opsBaseURL = "//ops.donkeysgo.com/";

  Vue.prototype.$serverUrl = "//api.donkeysgo.com/";
  localStorage.setItem('total_opsBaseURL', JSON.stringify(opsBaseURL))
} else if (window.location.host.startsWith("console.test.donkeysgo.com")) {
  localStorage.setItem('total_Global', JSON.stringify(xiaomaolv))
  localStorage.setItem('total_switchhost', 'true')
  baseURL = "//api.test.donkeysgo.com/";
  opsBaseURL = "//ops.test.donkeysgo.com/";
  // opsBaseURL = "//ops2.test.donkeysgo.com/";
  Vue.prototype.$serverUrl = "//api.test.donkeysgo.com/";
  localStorage.setItem('total_opsBaseURL', JSON.stringify(opsBaseURL))
} else if (window.location.host.startsWith("console.db.donkeysgo.com")) {
  localStorage.setItem('total_Global', JSON.stringify(xiaomaolv))
  localStorage.setItem('total_switchhost', 'true')
  baseURL = "//ops.db.donkeysgo.com/";
  opsBaseURL = "//ops.db.donkeysgo.com/";
  // opsBaseURL = "//ops2.test.donkeysgo.com/";
  Vue.prototype.$serverUrl = "//api.test.donkeysgo.com/";
  localStorage.setItem('total_opsBaseURL', JSON.stringify(opsBaseURL))
} else if (window.location.host.startsWith("console.dev.donkeysgo.com")) {
  localStorage.setItem('total_Global', JSON.stringify(xiaomaolv))
  localStorage.setItem('total_switchhost', 'true')
  // baseURL = "//api.test.donkeysgo.com/";
  opsBaseURL = "//ops.test.donkeysgo.com/";
  // opsBaseURL = "//192.168.8.16:33305/";
  // opsBaseURL = "//192.168.8.195:33305/";
  // opsBaseURL = "//ops.preview.donkeysgo.com/";
  // opsBaseURL = "//192.168.8.10:33305";
  // opsBaseURL = "//ops2.test.donkeysgo.com/";
  // opsBaseURL = "//7wswb5.natappfree.cc";
  Vue.prototype.$serverUrl = "//api.test.donkeysgo.com/";
  localStorage.setItem('total_opsBaseURL', JSON.stringify(opsBaseURL))
  
  } else if (window.location.host == "console.duoduogo.cn") {
  localStorage.setItem('total_Global', JSON.stringify(duoduo))
  localStorage.setItem('total_switchhost', 'false')
  baseURL = "//api.duoduogo.cn/";
  opsBaseURL = "//ops.duoduogo.cn/";

  Vue.prototype.$serverUrl = "//api.duoduogo.cn/";
  localStorage.setItem('total_opsBaseURL', JSON.stringify(opsBaseURL))
} else if (window.location.host.startsWith("console.test.duoduogo.cn")) {
  localStorage.setItem('total_Global', JSON.stringify(duoduo))
  localStorage.setItem('total_switchhost', 'false')
  baseURL = "//api.test.duoduogo.cn/";
  opsBaseURL = "//ops.test.duoduogo.cn/";

  Vue.prototype.$serverUrl = "//api.test.duoduogo.cn/";
  localStorage.setItem('total_opsBaseURL', JSON.stringify(opsBaseURL))
} else if (window.location.host.startsWith("console.dev.duoduogo.cn")) {
  localStorage.setItem('total_Global', JSON.stringify(duoduo))
  localStorage.setItem('total_switchhost', 'false')
  baseURL = "//api.test.duoduogo.cn/";
  opsBaseURL = "//ops.test.duoduogo.cn/";
  // opsBaseURL = "//192.168.8.28:33305/";
  Vue.prototype.$serverUrl = "//api.test.duoduogo.cn/";
  localStorage.setItem('total_opsBaseURL', JSON.stringify(opsBaseURL))
}else if (window.location.host.startsWith("tongxiang.console.donkeysgo.com")) {
  localStorage.setItem('total_Global', JSON.stringify(tongxiang))
  localStorage.setItem('total_switchhost', 'tongxiang')
  localStorage.setItem('ifSolopay', true)
  baseURL = "//tongxiang.api.donkeysgo.com/";
  opsBaseURL = "https://tongxiang.ops.donkeysgo.com/";
  Vue.prototype.$serverUrl = "///tongxiang.api.donkeysgo.com/";
  localStorage.setItem('agent_title', '桐乡出行')
} else if (window.location.host.startsWith("tongxiang.console.test.donkeysgo.com")) {
  localStorage.setItem('total_Global', JSON.stringify(tongxiang))
  localStorage.setItem('total_switchhost', 'tongxiang')
  localStorage.setItem('ifSolopay', true)
  baseURL = "//tongxiang.api.test.donkeysgo.com/";
  opsBaseURL = "https://tongxiang.ops.test.donkeysgo.com/";
  Vue.prototype.$serverUrl = "///tongxiang.api.test.donkeysgo.com/";
  localStorage.setItem('agent_title', '桐乡出行')
}else if (window.location.host.startsWith("rental.console.donkeysgo.com")) {
  localStorage.setItem('total_Global', JSON.stringify(rental))
  localStorage.setItem('total_switchhost', 'rental')
  localStorage.setItem('ifSolopay', true)
  baseURL = "//rental.api.donkeysgo.com/";
  opsBaseURL = "https://rental.ops.donkeysgo.com/";
  Vue.prototype.$serverUrl = "///rental.api.donkeysgo.com/";
  localStorage.setItem('agent_title', '时租车')
} else if (window.location.host.startsWith("rental.console.test.donkeysgo.com")) {
  localStorage.setItem('total_Global', JSON.stringify(rental))
  localStorage.setItem('total_switchhost', 'rental')
  localStorage.setItem('ifSolopay', true)
  baseURL = "//rental.api.test.donkeysgo.com/";
  opsBaseURL = "https://rental.ops.test.donkeysgo.com/";
  Vue.prototype.$serverUrl = "///rental.api.test.donkeysgo.com/";
  localStorage.setItem('agent_title', '时租车')
}else if (window.location.host.startsWith("zhongluo.console.donkeysgo.com")) {
  localStorage.setItem('total_Global', JSON.stringify(zhongluo))
  localStorage.setItem('total_switchhost', 'zhongluo')
  localStorage.setItem('ifSolopay', true)
  localStorage.setItem('ifProfit', true)
  baseURL = "//zhongluo.api.donkeysgo.com/";
  opsBaseURL = "https://zhongluo.ops.donkeysgo.com/";
  Vue.prototype.$serverUrl = "///zhongluo.api.donkeysgo.com/";
  localStorage.setItem('agent_title', '北斗驴')
} else if (window.location.host.startsWith("zhongluo.console.test.donkeysgo.com")) {
  localStorage.setItem('total_Global', JSON.stringify(zhongluo))
  localStorage.setItem('total_switchhost', 'zhongluo')
  localStorage.setItem('ifSolopay', true)
  localStorage.setItem('ifProfit', true)
  baseURL = "//zhongluo.api.test.donkeysgo.com/";
  opsBaseURL = "https://zhongluo.ops.test.donkeysgo.com/";
  Vue.prototype.$serverUrl = "///zhongluo.api.test.donkeysgo.com/";
  localStorage.setItem('agent_title', '北斗驴')
}else if (window.location.host.startsWith("xianlvv2.console.donkeysgo.com")) {
  localStorage.setItem('total_Global', JSON.stringify(xianlvv2))
  localStorage.setItem('total_switchhost', 'xianlvv2')
  localStorage.setItem('ifSolopay', true)
  localStorage.setItem('ifProfit', true)
  baseURL = "//xianlvv2.api.donkeysgo.com/";
  opsBaseURL = "https://xianlvv2.ops.donkeysgo.com/";
  Vue.prototype.$serverUrl = "///xianlvv2.api.donkeysgo.com/";
  localStorage.setItem('agent_title', '闲驴两轮')
} else if (window.location.host.startsWith("xianlvv2.console.test.donkeysgo.com")) {
  localStorage.setItem('total_Global', JSON.stringify(xianlvv2))
  localStorage.setItem('total_switchhost', 'xianlvv2')
  localStorage.setItem('ifSolopay', true)
  localStorage.setItem('ifProfit', true)
  baseURL = "//xianlvv2.api.test.donkeysgo.com/";
  opsBaseURL = "https://xianlvv2.ops.test.donkeysgo.com/";
  Vue.prototype.$serverUrl = "///xianlvv2.api.test.donkeysgo.com/";
  localStorage.setItem('agent_title', '闲驴两轮')
}else if (window.location.host.startsWith("kaifeng.console.donkeysgo.com")) {
  localStorage.setItem('total_Global', JSON.stringify(kaifeng))
  localStorage.setItem('total_switchhost', 'kaifeng')
  localStorage.setItem('ifSolopay', true)
  localStorage.setItem('ifProfit', true)
  baseURL = "//kaifeng.api.donkeysgo.com/";
  opsBaseURL = "https://kaifeng.ops.donkeysgo.com/";
  Vue.prototype.$serverUrl = "///kaifeng.api.donkeysgo.com/";
  localStorage.setItem('agent_title', '骑达')
} else if (window.location.host.startsWith("kaifeng.console.test.donkeysgo.com")) {
  localStorage.setItem('total_Global', JSON.stringify(kaifeng))
  localStorage.setItem('total_switchhost', 'kaifeng')
  localStorage.setItem('ifSolopay', true)
  localStorage.setItem('ifProfit', true)
  baseURL = "//kaifeng.api.test.donkeysgo.com/";
  opsBaseURL = "https://kaifeng.ops.test.donkeysgo.com/";
  Vue.prototype.$serverUrl = "///kaifeng.api.test.donkeysgo.com/";
  localStorage.setItem('agent_title', '骑达')
}else if (window.location.host.startsWith("ganzhou.console.donkeysgo.com")) {
  localStorage.setItem('total_Global', JSON.stringify(ganzhou))
  localStorage.setItem('total_switchhost', 'ganzhou')
  localStorage.setItem('ifSolopay', true)
  localStorage.setItem('ifProfit', true)
  baseURL = "//ganzhou.api.donkeysgo.com/";
  opsBaseURL = "https://ganzhou.ops.donkeysgo.com/";
  Vue.prototype.$serverUrl = "///ganzhou.api.donkeysgo.com/";
  localStorage.setItem('agent_title', '彪骑士')
} else if (window.location.host.startsWith("ganzhou.console.test.donkeysgo.com")) {
  localStorage.setItem('total_Global', JSON.stringify(ganzhou))
  localStorage.setItem('total_switchhost', 'ganzhou')
  localStorage.setItem('ifSolopay', true)
  localStorage.setItem('ifProfit', true)
  baseURL = "//ganzhou.api.test.donkeysgo.com/";
  opsBaseURL = "https://ganzhou.ops.test.donkeysgo.com/";
  Vue.prototype.$serverUrl = "///ganzhou.api.test.donkeysgo.com/";
  localStorage.setItem('agent_title', '彪骑士')
}  else {
  alert("域名不对");
}
// axios.defaults.baseURL = 'http://192.168.8.204/'
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
// if(localStorage.getItem('token')){
//     axios.defaults.headers.common['auth'] = localStorage.getItem('token');
// }



// var token = localStorage.getItem('token')
// console.log("token"+token);
Vue.prototype.$axios = axios.create({
  baseURL: baseURL,
  timeout: 20000,
  headers: {
    post: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
    common: {
      auth: localStorage.getItem("total_token"),
    },
  },
});

Vue.prototype.$axios.interceptors.response.use(
  (response) => {
    // 如果返回的状态码为200，说明接口请求成功，可以正常拿到数据
    // 否则的话抛出错误
    // console.log("response.data");
    if (response.status === 200) {
      // console.log(response.data)
      if (response.data && response.data.code == "77777") {
        // console.log("re")
        router.push({ path: "/login" });
        return;
      }
      return Promise.resolve(response);
    } else {
      return Promise.reject(response);
    }
  },
  (error) => {
    if (error == "Error: Network Error") {
      Message.error("网络错误！");
      return false;
    }

    return Promise.reject(error.response);
  }
)





const messageOnce = new domMessage()
// console.log(localStorage.getItem("token"))
Vue.prototype.$opsaxios = axios.create({
  baseURL: opsBaseURL,
  timeout: 20000,
  withCredentials: true,
  headers: {
    post: {
      "Content-Type": "application/json",
    },
    common: {
      MemberAuthorization: localStorage.getItem("total_token"),
    },
  },
});
Vue.prototype.$opsaxios.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("total_token");
    // console.info("567", config)
    // console.info("789", config.headers)
    if (token) {
      // 判断是否存在token，如果存在的话，则每个http header都加上token
      config.headers.MemberAuthorization = token;
    }
    config.url = config.url + '?rand=' + Date.now() + '_' + Math.random();
    return Promise.resolve(config);
  },
  error => {
    return Promise.reject(error)
  }
)
Vue.prototype.$opsaxios.interceptors.response.use(
  (response) => {
    // 如果返回的状态码为200，说明接口请求成功，可以正常拿到数据
    // 否则的话抛出错误
    // console.log("response.data");
    if (response.status === 200) {
      // console.log(response.data)
      if (response.data.code == "-1003" || response.data.code == "-2015") {
        messageOnce.warning({
          message: response.data.message,
          type: 'warning'
        })
        localStorage.removeItem('total_token');
        router.push({ path: "/login" });
        return;
      }
      if (response.data.code == "-90008") {
        messageOnce.warning({
          message: "登陆过期，请重新登陆",
          type: 'warning'
        })
        localStorage.removeItem('total_token');
        router.push({ path: "/login" });
        return;
      }
      // if (response.data && response.data.code == "-2034") {
      //   router.push({ path: "/helloPage" });
      //   return;
      // }
      return Promise.resolve(response);
    } else {
      return Promise.reject(response);
    }
  },
  (error) => {
    if (error == "Error: Network Error") {
      Message.error("网络错误！");
      return false;
    }
    return Promise.reject(error.response);
  }
);

axios.defaults.withCredentials = true;
Vue.prototype.$ossaxios = axios.create({
  baseURL: "/gamutgameshow",
  timeout: 20000,
  withCredentials: true,
  headers: {
    post: {
      "Content-Type": "application/json",
    },
    common: {
      MemberAuthorization: localStorage.getItem("total_token"),
    },
  },
});


Vue.prototype.$ossaxios.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("total_token");
    // console.info("567", config)
    // console.info("789", config.headers)
    if (token) {
      // 判断是否存在token，如果存在的话，则每个http header都加上token
      config.headers.MemberAuthorization = token;
    }
    config.url = config.url;
    return Promise.resolve(config);
  },
  error => {
    return Promise.reject(error)
  }
)

Vue.prototype.$ossaxios.interceptors.response.use(
  (response) => {
    // 如果返回的状态码为200，说明接口请求成功，可以正常拿到数据
    // 否则的话抛出错误
    // console.log("response.data");
    if (response.status === 200) {
      // console.log(response.data)
      if (response.data.code == "-1003") {
        messageOnce.warning({
          message: response.data.message,
          type: 'warning'
        })
        router.push({ path: "/login" });
        return;
      }
      if (response.data.code == "-2015") {
        messageOnce.warning({
          message: response.data.message,
          type: 'warning'
        })
        localStorage.removeItem('total_token');
        router.push({ path: "/login" });
        return;
      }
      // if (response.data && response.data.code == "-2034") {
      //   router.push({ path: "/helloPage" });
      //   return;
      // }
      return Promise.resolve(response);
    } else {
      return Promise.reject(response);
    }
  },
  (error) => {
    if (error == "Error: Network Error") {
      Message.error("网络错误！");
      return false;
    }
    return Promise.reject(error.response);
  }
);















import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
Vue.use(ElementUI);
Vue.config.debug = true;
Vue.config.productionTip = false;
Vue.prototype.FrontVersion = window.GlobalFrontVersion

// 加载XLSX
import XLSX from 'xlsx';
Vue.use(XLSX);
// md5加密
import md5 from 'js-md5'
Vue.prototype.$md5 = md5

// 引入echarts
Vue.prototype.$echarts = echarts
import echarts from 'echarts'
// 加载富文本编辑器
import VueQuillEditor from "vue-quill-editor";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
Vue.use(VueQuillEditor);
/* eslint-disable no-new */

let EXPIRESTIME = 86400000;

router.beforeEach((to, from, next) => {
  // console.info("to", to)
  // console.info("from", from)
  // console.info("next", next)
  const isLogin = localStorage.getItem("total_token");
  let item = localStorage.getItem("countdown");
  try {
    item = JSON.parse(item);
  } catch (error) {
    // eslint-disable-next-line no-self-assign
    item = item;
  }
  if (item) {
    let date = new Date().getTime();
    //     // 如果大于就是过期了，如果小于或等于就还没过期
    if (date - item.startTime > EXPIRESTIME) {
      localStorage.removeItem('total_token');
      
    }
  }
  if (to.name == '登录') {
    if (isLogin != null) {
      next({ name: '工作台' });
    } else {
      next();
    }
  } else {
    if (isLogin != null) {
      next();
    } else {
      next({ name: '登录' });
      messageOnce.warning({
        message: '登录已过期，请重新登录！',
        type: 'warning'
      })
    }
  }
});

new Vue({
  el: "#app",
  router,
  components: { App },
  template: "<App/>",
});



// WEBPACK FOOTER //
// ./src/main.js